"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.initialValues = exports.icon = exports.getMetrics = exports.getDataDefinitions = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _itemTypes = _interopRequireDefault(require("./itemTypes"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdVideo = require("cccisd-video");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var fields = exports.fields = function () {
  var result = [];

  // Item types
  (0, _forEach2["default"])(_itemTypes["default"], function (itemType, name) {
    itemType.fields.forEach(function (field) {
      result.push("itemTypes.".concat(name, "[].").concat(field));
    });
  });
  return ['question', 'description', 'completeCondition', 'minimumNumber', 'items[].id', 'items[].code', 'items[].type', 'items[].label', 'items[].isExpanded', 'completeAllErrorMessage', 'completeMinErrorMessage', 'isItemsExpanded', 'isBackgroundExpanded', 'background'].concat(result);
}();
var ttsFields = exports.ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings;
  var result = ['question', 'description'];
  result.push.apply(result, _toConsumableArray(settings.items.map(function (item, index) {
    return "items[".concat(index, "].label");
  })));
  settings.itemTypes["static"].forEach(function (item, index) {
    if (item.contentType === 'text') {
      result.push("itemTypes.static[".concat(index, "].text"));
    }
  });
  return result;
};
var initialValues = exports.initialValues = {
  question: '<p><strong>What is your opinion about ...?</strong></p>',
  completeCondition: 'all',
  minimumNumber: 1,
  isItemsExpanded: true,
  items: [{
    id: 1,
    label: 'Item 1',
    type: 'static'
  }, {
    id: 2,
    label: 'Item 2',
    type: 'static'
  }, {
    id: 3,
    label: 'Item 3',
    type: 'static'
  }],
  itemTypes: {
    "static": [{
      id: 1,
      contentType: 'text',
      text: 'Item 1 description',
      video: _objectSpread({}, _cccisdVideo.builderInitialValues)
    }, {
      id: 2,
      contentType: 'text',
      text: 'Item 2 description',
      video: _objectSpread({}, _cccisdVideo.builderInitialValues)
    }, {
      id: 3,
      contentType: 'text',
      text: 'Item 3 description',
      video: _objectSpread({}, _cccisdVideo.builderInitialValues)
    }]
  },
  completeAllErrorMessage: 'You have to complete all items before advancing',
  completeMinErrorMessage: "You have to complete at least :min items before advancing",
  isBackgroundExpanded: true,
  background: 'default'
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-th-list"
});
var validate = exports.validate = function validate(values) {
  var errors = {};
  (0, _forEach2["default"])(_itemTypes["default"], function (element, type) {
    var elementErrors = (0, _cccisdSurveyCommon.validateElement)(values.itemTypes[type], element.validate);
    if (elementErrors.length === 0) {
      return;
    }
    errors = _objectSpread(_objectSpread({}, errors), {}, {
      itemTypes: _objectSpread(_objectSpread({}, errors.itemTypes), {}, _defineProperty({}, type, elementErrors))
    });
  });
  return errors;
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  return {};
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  return {};
};